import { CSS } from "@stitches/react";
import { Link } from "./__styles__/LinkCell";

const LinkCell = ({
  href,
  label = "Link",
  target,
  css,
}: {
  href: string;
  label?: string;
  target?: string;
  css?: CSS;
}) => {
  return (
    <Link href={href} target={target} tabIndex={0} css={css}>
      {label}
    </Link>
  );
};

export default LinkCell;
